export var LOG_PREFIX = 'storage:redis: ';
export var DEFAULT_CACHE_SIZE = 30000;
export var REFRESH_RATE = 300000; // 300.000 ms = start after 5 mins
export var TTL_REFRESH = 3600; // 1hr



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/storages/inRedis/constants.js
// module id = 608
// module chunks = 31